import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { bool, string } from 'prop-types'
import { Alert } from 'antd'
import { useQuery } from '@tanstack/react-query'

import api from 'services/api'
import Loader from 'components/loader'
import DocumentTextEditor from 'pages/documentDetails/components/editor'

import {
	PreviewContainer,
	LoaderContainer,
	ErrorMessage,
	AlertContainer,
} from './styles'

const ContractPreview = ({ show, isExternal, templateId }) => {
	const { data: template, loading: loadingTemplate } = useSelector(
		({ editTemplate }) => editTemplate
	)
	const { loading: loadingExternalData } = useSelector(
		({ externalContract }) => externalContract
	)
	const { loading: loadingQuestions, textType } = useSelector(
		({ question }) => question
	)
	const { data: answer } = useSelector(({ answer }) => answer)

	const documentTemplateId = isExternal ? templateId : template?.id

	const {
		data: preview,
		isLoading,
		isError,
	} = useQuery({
		queryKey: ['contract-preview', documentTemplateId, answer],
		queryFn: fetchContractPreview,
		enabled:
			!loadingTemplate &&
			!loadingExternalData &&
			!loadingQuestions &&
			!!template &&
			!!answer,
		staleTime: 1000 * 30,
		refetchOnWindowFocus: false,
		retry: false,
	})

	const [error, setError] = useState(null)

	async function fetchContractPreview() {
		try {
			// Add contract date to display on the preview
			const variables = {
				DATA_GERACAO_CONTRATO: new Date().toISOString(),
				...answer,
			}

			const { data } = await api.post('/templates/render', {
				document_template_id: documentTemplateId,
				variables,
			})

			return data.document_template
		} catch (error) {
			console.log(error)
			setError({
				message:
					'Tivemos um problema ao gerar o resumo do seu documento. Por favor, entre em contato com time de suporte. Caso deseje continuar com o cadastro do documento clique no botão de Salvar.',
				error: error.toString(),
			})
			return null
		}
	}

	if (textType !== '.txt' || !show) return null
	if (isError) {
		return (
			<>
				<AlertContainer>
					<Alert
						type="info"
						message="Please review the power of attorney details to ensure they are correct
                    before submitting it for the Officers approval"
						showIcon
					/>
				</AlertContainer>
				<PreviewContainer>
					<ErrorMessage>{error.message}</ErrorMessage>
				</PreviewContainer>
			</>
		)
	}
	if (loadingTemplate || loadingQuestions || isLoading) {
		return (
			<PreviewContainer>
				<LoaderContainer>
					<Loader />
				</LoaderContainer>
			</PreviewContainer>
		)
	}

	return (
		<>
			<AlertContainer>
				<Alert
					type="info"
					message="Please review the power of attorney details to ensure they are correct
                    before submitting it for the Officers approval"
					showIcon
				/>
			</AlertContainer>

			<PreviewContainer>
				<DocumentTextEditor
					text={preview}
					onUpdateText={() => {}}
					block={true}
					versionLoading={false}
					title="Preview"
					ckeditorCss={template.ckeditorCss}
					ckeditorStyles={template.ckeditorStyles}
				/>
			</PreviewContainer>
		</>
	)
}

export default ContractPreview

ContractPreview.propTypes = { show: bool, isExternal: bool, templateId: string }
